// ═══ 말소 상세 단계 바 — 대기 → 접수 → 번호판 수거완료 → 완료 (plan.md §6 · B3 리뷰 §2.3) ═══
// 단계 매핑은 CancelTrackingScreen.dispIndex 그대로(진행중·보류 = 접수 칸). 보류는 현재 칸을 amber 로 칠하고
// 아래에 사유 한 줄(fixReqHoldReasonCue). 모양은 FinalWeb2 `.prog`(원 22 + 연결선 2).
// props: { status, holdReason }
import React from 'react';
import { T, R, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { dispIndex } from '../../docs/CancelTrackingScreen';

var LABEL_KEYS = ['cancelAgencyStatusWaiting', 'cancelAgencyStatusReceived', 'cancelAgencyStatusPickedUp', 'cancelAgencyStatusDone'];

var wrap = { display: 'flex', alignItems: 'flex-start', padding: '14px 12px' };
var cell = { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
  fontSize: FONT.label, textAlign: 'center', position: 'relative' };
var line = { position: 'absolute', top: 10, insetInlineStart: '-50%', insetInlineEnd: '50%', height: 2 };
var dotBase = { width: 22, height: 22, borderRadius: '50%', boxSizing: 'border-box', position: 'relative', zIndex: 1,
  display: 'grid', placeItems: 'center', fontSize: FONT.label, fontWeight: 800, fontStyle: 'normal', direction: 'ltr' };
var cue = { margin: '0 12px 12px', padding: '9px 12px', borderRadius: R.md, background: T.warnTint,
  border: '1px solid ' + T.warnBd, color: T.warn, fontSize: FONT.body, fontWeight: 700 };

/// i < cur 'done' · i === cur 'current'(보류면 'hold') · 그 뒤 'todo'.
export function stepStates(status) {
  var cur = dispIndex(status);
  var hold = status === '보류';
  return LABEL_KEYS.map(function (k, i) {
    if (i < cur) return 'done';
    if (i === cur) return hold ? 'hold' : 'current';
    return 'todo';
  });
}

function dotStyle(state) {
  if (state === 'hold') return Object.assign({}, dotBase, { background: T.card, border: '2px solid ' + T.dotWarn, color: T.warn });
  if (state === 'todo') return Object.assign({}, dotBase, { background: T.card, border: '2px solid ' + T.bd, color: T.faint });
  return Object.assign({}, dotBase, { background: T.navy, border: '2px solid ' + T.navy, color: T.card,
    boxShadow: state === 'current' ? '0 0 0 3px ' + T.accentBd : 'none' });
}

function MalsoStepper(props) {
  var t = useT();
  var states = stepStates(props.status);
  var reason = props.status === '보류' ? String(props.holdReason || '').trim() : '';
  return (<div data-part="malso-stepper">
    <div style={wrap}>
      {states.map(function (s, i) {
        var reached = s !== 'todo';
        return (<div key={LABEL_KEYS[i]} data-step={i} data-state={s} style={Object.assign({}, cell, {
          color: s === 'hold' ? T.warn : reached ? T.navy : T.faint, fontWeight: s === 'current' || s === 'hold' ? 800 : 600 })}>
          {i > 0 ? <span style={Object.assign({}, line, { background: reached ? T.navy : T.bd })} /> : null}
          <i style={dotStyle(s)}>{s === 'done' || s === 'current' ? '✓' : String(i + 1)}</i>
          {t(LABEL_KEYS[i])}
        </div>);
      })}
    </div>
    {reason ? <div data-cue="hold" style={cue}>{t('fixReqHoldReasonCue', { reason: reason })}</div> : null}
  </div>);
}

export default MalsoStepper;
